/*
 * assets/js/src/kontakt.js — mapa kanceláře na stránce Kontakt.
 *
 * Předloha `navrh-kontakt.html`. Chování z návrhu se drží doslova:
 * na desktopu a tabletu se mapa vykreslí rovnou, na mobilu až na
 * klepnutí, aby se cizí dlaždice netahaly, než o ně člověk stojí.
 *
 * Knihovna je TÁŽ jako ve výpisu a na detailu lokality (`ol.js` z
 * `assets/js/require/`), takže se nestahuje druhá kopie OpenLayers.
 *
 * Bez knihovny, bez souřadnic nebo bez rámu se nestaví nic a rám
 * zůstane s tlačítkem — prázdná šedá plocha je horší než tlačítko,
 * které nic neslibuje.
 */

/** Pin kanceláře. Tvar i barvy z návrhu (`--cyan` s bílým obrysem). */
function pinKancelar() {
	const svg =
		'<svg xmlns="http://www.w3.org/2000/svg" width="30" height="40" viewBox="0 0 28 38">' +
		'<path d="M14 36.4C5.8 25.2 2.2 20.2 2.2 14A11.8 11.8 0 0 1 25.8 14c0 6.2-3.6 11.2-11.8 22.4z"' +
		' fill="#00B7CD" stroke="#ffffff" stroke-width="2.4"/>' +
		'<circle cx="14" cy="13.6" r="4.5" fill="#ffffff"/></svg>';
	return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
}

/**
 * Mapa kanceláře.
 *
 * Vrací 1, když se mapa opravdu postavila, jinak 0. Návratová hodnota
 * není kosmetika — v důkazu integrace se proti ní počítá, kolik
 * ovladačů nad jedním prvkem běží.
 */
export function init() {
	const ram = document.querySelector('.mapsec .mapframe');
	const data = window.ZA2026_KONTAKT || null;
	if (!ram || !data || 'number' !== typeof data.lat || 'number' !== typeof data.lng) return 0;

	const cil = ram.querySelector('.olmap');
	const btn = ram.querySelector('.mapbtn');
	if (!cil) return 0;

	let hotovo = false;

	const postav = () => {
		const ol = window.ol;
		if (hotovo || !ol) return 0;
		hotovo = true;
		ram.classList.add('je-nactena');

		const f = new ol.Feature({ geometry: new ol.geom.Point(ol.proj.fromLonLat([data.lng, data.lat])) });
		f.setStyle(new ol.style.Style({ image: new ol.style.Icon({ anchor: [0.5, 1], src: pinKancelar(), scale: 1.4 }) }));

		const map = new ol.Map({
			target: cil,
			controls: [],
			layers: [
				new ol.layer.Tile({ source: new ol.source.OSM() }),
				new ol.layer.Vector({ source: new ol.source.Vector({ features: [f] }) }),
			],
			view: new ol.View({ center: ol.proj.fromLonLat([data.lng, data.lat]), zoom: 16, maxZoom: 19, minZoom: 5 }),
		});
		window.addEventListener('resize', () => map.updateSize());

		const zin = ram.querySelector('.mapzoom .zin');
		const zout = ram.querySelector('.mapzoom .zout');
		if (zin) zin.addEventListener('click', () => map.getView().animate({ zoom: map.getView().getZoom() + 1, duration: 220 }));
		if (zout) zout.addEventListener('click', () => map.getView().animate({ zoom: map.getView().getZoom() - 1, duration: 220 }));
		return 1;
	};

	if (btn) btn.addEventListener('click', postav);
	if (window.matchMedia('(min-width:768px)').matches) postav();
	return 1;
}
